import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  CanLoad,
  Route,
  UrlSegment
} from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import {
  selectUserAssignedGroups,
  selectIsAuthenticated
} from '../store/auth.selectors';
import { map, withLatestFrom, first } from 'rxjs/operators';
import { USER_GROUP_PORTALS } from '../model/user-groups.enum';
import { GroupMediatorService } from '../services/group-mediator.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate, CanLoad {
  constructor(
    private store: Store,
    private groupMediatorService: GroupMediatorService
  ) {}
  canLoad(
    route: Route,
    segments: UrlSegment[]
  ): boolean | Observable<boolean> | Promise<boolean> {
    return this.store.select(selectUserAssignedGroups).pipe(
      first(),
      map(userGroups =>
        this.groupMediatorService.canLoadModule(
          userGroups,
          USER_GROUP_PORTALS.ADMIN,
          segments
        )
      )
    );
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.store.select(selectUserAssignedGroups).pipe(
      withLatestFrom(this.store.select(selectIsAuthenticated)),
      map(([userGroups, isAuthenticated]) => {
        return this.groupMediatorService.canGroupActivateModule(
          isAuthenticated,
          userGroups,
          USER_GROUP_PORTALS.ADMIN,
          state.url
        );
      })
    );
  }
}
